import { useEffect, useState } from 'react';

/**
 * A value that settles before anything acts on it.
 *
 * For a box whose every keystroke would otherwise be a query. The investor Q&A
 * search runs a semantic lookup over an embedding index per call, so typing a
 * six-word question unthrottled is six embeddings computed and five of them
 * thrown away.
 */
export function useDebounced(value, delay = 350) {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);
  return settled;
}
